export const models = [
  { url: "/models/nikita.glb", name: "Model 1" },
  { url: "/models/model-2.glb", name: "Model 2" },
];

export const Models = {
  nikita: "",
  pratik: "",
  shah: "",
  female_doctor: "",
  maleMiddle: "",
  femaleMiddle: "",
  pratik_s: "",
  female_doctor2: "",
  female_doctor3: "",
  male_doctor1: "",
  male_doctor2: "",
  technician1: "",
  asian1: "",
  female1: "",
  male1: "",
  female2: "",
  male2: "",
  male3: "",
  male_engineer: "",
  ryan: "",
  jiajun: "",
  irene: "",
  desi_woman: "",
  end_call: "/models/endCallBtn.glb",
  mute: "/models/Mute.glb",
  unmute: "/models/Unmute.glb",
};
